/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Dispatch } from '../redux';
import { DocumentsAPI } from '../api/common/documents';
import { CommonAPI } from '../api/common/responses';

export function updateExitModalStatus(isExitModalOpen: boolean) {
  return (dispatch: Dispatch) => {
    return dispatch({ type: 'UPDATE_EXIT_MODAL_STATE', payload: isExitModalOpen });
  };
}

export function setSigningAction(signingAction: DocumentsAPI.ActionResponse) {
  return (dispatch: Dispatch) => {
    return dispatch({ type: 'SET_SIGNING_ACTION', payload: signingAction });
  };
}

export function setUsers(users: CommonAPI.UserDataResponse) {
  return (dispatch: Dispatch) => {
    return dispatch({ type: 'SET_USERS', payload: users });
  };
}

export function setSelectedNavigationItemId(navigationItemId: string) {
  return (dispatch: Dispatch) => {
    return dispatch({ type: 'SET_SELECTED_NAVIGATION_ITEM_ID', payload: navigationItemId });
  };
}
